import { render, staticRenderFns } from "./homeNewsParticulars.vue?vue&type=template&id=521e0d12&scoped=true&"
import script from "./homeNewsParticulars.vue?vue&type=script&lang=js&"
export * from "./homeNewsParticulars.vue?vue&type=script&lang=js&"
import style0 from "./homeNewsParticulars.vue?vue&type=style&index=0&id=521e0d12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521e0d12",
  null
  
)

export default component.exports